import React from 'react';
import { NavLink } from 'react-router-dom';
import BrandMark from '../BrandMark';
import './BuzzerSolo.css';

const navItems = [
  { to: '/solo/floor', label: 'Live Floor' },
  { to: '/solo/tables', label: 'Areas & Tables' },
  { to: '/solo/team', label: 'Team' },
  { to: '/solo/analytics', label: 'Analytics' },
  { to: '/solo/billing', label: 'Billing' },
  { to: '/solo/settings', label: 'Settings' },
];

export default function SoloShell({ title, subtitle, actions = null, children }) {
  return (
    <div className="bsolo-page">
      <div className="bsolo-shell">
        <div className="bsolo-brandbar">
          <BrandMark href="/" size={34} />
        </div>

        <div className="bsolo-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="bsolo-card" style={{ marginBottom: 18 }}>
          <div className="bsolo-row" style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <h1 className="bsolo-title">{title}</h1>
              {subtitle ? <p className="bsolo-muted" style={{ margin: 0 }}>{subtitle}</p> : null}
            </div>
            {actions}
          </div>
        </div>

        {children}
      </div>
    </div>
  );
}
